import helpers from './helpers';

export default ( Vue ) =>
{
    Object.defineProperties( Vue.prototype, {
        $helpers: {
            get()
            {
                return helpers;
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/plugins/index.js